import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetAvailableCountriesStateParameter } from "@store/Framework/Services/CartUtilitiesService";
import CartUtilitiesState from "@store/Framework/Store/Store/Data/CartUtilities/CartUtilitiesState";
import { StatesCountriesFilterModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: CartUtilitiesState = {
    countryStateFilter: [],
};

const actions = {
    "Store/Data/CartUtilities/SetFilteredCountriesStates": (
        draft: Draft<CartUtilitiesState>,
        action: { parameter: GetAvailableCountriesStateParameter; countryStateFilter: StatesCountriesFilterModel[] },
    ) => {
        draft.countryStateFilter = action.countryStateFilter;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreCartUtilitiesActions = Parameters<typeof reducer>[1];
export default reducer;
